// @flow

export const BAGGAGE_TYPE = {
  HAND_BAG: "handBag",
  HOLD_BAG: "holdBag",
}
export const CATEGORY_API_CONVERTER = {
  hold_bag: "holdBag",
  hand_bag: "handBag",
  personal_item: "personalItem",
  cabin_bag: "cabinBag",
}
export const CATEGORY_TO_API_CONVERTER = {
  holdBag: "hold_bag",
  handBag: "hand_bag",
  personalItem: "personal_item",
  cabinBag: "cabin_bag",
}
export const CONDITION_API_CONVERTER = {
  passenger_groups: "passengerGroups",
  is_priority: "isPriority",
}
export const CONDITION_TO_API_CONVERTER = {
  passengerGroups: "passenger_groups",
  isPriority: "is_priority",
}
export const REINITIALIZE = "baggage/REINITIALIZE"
export const SELECT_PASSENGER_BAGGAGE = "baggage/SELECT_PASSENGER_BAGGAGE"
export const CHANGE_PASSENGER_HOLD_BAG = "baggage/CHANGE_PASSENGER_HOLD_BAG"
export const CHANGE_PASSENGER_HAND_BAG = "baggage/CHANGE_PASSENGER_HAND_BAG"
export const LOAD_BAGGAGE = "baggage/LOAD_BAGGAGE"
export const LOAD_BAGGAGE_FAILURE = "baggage/LOAD_BAGGAGE_FAILURE"
export const LOAD_BAGGAGE_SUCCESS = "baggage/LOAD_BAGGAGE_SUCCESS"
